<template lang="pug">
    Modal(v-if="show" modalWidth="medium" @close="$emit('close')" :classes="['ncsa_modal']")
      span(slot="header")
        img( class="modal_ncsa_logo" alt='NCSA Logo' :src="ncsalogo")
      template(slot="content")
        .modal-content.centered(v-if="done")
          img( class="green_check" alt='green_check' :src="green_check")
          h5 {{t('app.ncsa.congrats')}}
          p {{t('app.ncsa.congrats_message')}}
          a(@click="$emit('close_success')" class="button secondary") {{t('app.buttons.close')}}

        validation-observer(v-else ref="observer" tag="div" class="modal-content" )
          .row
            .columns.large-24
              h5 {{t('app.ncsa.modal_title')}}
              <span v-html="t('app.ncsa.list_item_1')"></span>
          .row
            .columns.large-24.block-header
              | {{t('app.ncsa.parent_info')}}
          .row
            .columns.large-12
              .field
                label
                  | {{t('app.ncsa.first_name')}}
                  span.required *
                validation-provider(rules="required" name="parent_first_name" v-slot="{ errors }")
                  input(type="text" v-model="data.parent_first_name" :class="{error: errors[0]}")
            .columns.large-12
              .field
                label
                  | {{t('app.ncsa.last_name')}}
                  span.required *
                validation-provider(rules="required" name="parent_last_name" v-slot="{ errors }")
                  input(type="text" v-model="data.parent_last_name" :class="{error: errors[0]}")
          .row
            .columns.large-12
              .field
                label
                  | {{t('app.ncsa.email')}}
                  span.required *
                validation-provider(rules="required|email" name="parent_email" v-slot="{ errors }")
                  input(type="email" v-model="data.parent_email" :class="{error: errors[0]}")
            .columns.large-12
              .field
                label
                  | {{t('app.ncsa.phone')}}
                  span.required *
                validation-provider(rules="required" name="parent_phone" v-slot="{ errors }")
                  phone(v-model="data.parent_phone" :errors="errors" @valid="custom_valid1=$event")
          .row
            .columns.large-24.block-header
              | {{t('app.ncsa.student_info')}}
          .row
            .columns.large-12
              .field
                label
                  | {{t('app.ncsa.first_name')}}
                  span.required *
                validation-provider(rules="required" name="athlete_first_name" v-slot="{ errors }")
                  input(type="text" v-model="data.athlete_first_name" :class="{error: errors[0]}")
            .columns.large-12
              .field
                label
                  | {{t('app.ncsa.last_name')}}
                  span.required *
                validation-provider(rules="required" name="athlete_last_name" v-slot="{ errors }")
                  input(type="text" v-model="data.athlete_last_name" :class="{error: errors[0]}")
          .row
            .columns.large-12
              .field.datepicker
                label
                  | {{t('app.ncsa.birth_date')}}
                  span.required *
                validation-provider(rules="required" name="birth_date" v-slot="{ errors }")
                  span(:class="{error: errors[0]}")
                    flat-pickr(
                      v-model="data.birth_date" :config="conf" placeholder="mm-dd-yyyy" :class="{error: errors[0]}")
                    .prefix.date(data-toggle)
                      span.icon-calendar
            .columns.large-12
              .field
                label
                  | {{t('app.ncsa.zip')}}
                  span.required *
                validation-provider(rules="required" name="zip" v-slot="{ errors }")
                  input(type="text" v-model="data.zip" :class="{error: errors[0]}")
            span.error(v-if="birth_date_error")
              | {{t('app.ncsa.birth_date_error')}}
          .row
            .columns.large-12
              .field
                label
                  | {{t('app.ncsa.email')}}
                  span.required *
                validation-provider(rules="required|email" name="athlete_email" v-slot="{ errors }")
                  input(type="email" v-model="data.athlete_email" :class="{error: errors[0]}")
            .columns.large-12
              .field
                label
                  | {{t('app.ncsa.phone')}}
                  span.required *
                validation-provider(rules="required" name="athlete_phone" v-slot="{ errors }")
                  phone(v-model="data.athlete_phone" :errors="errors" @valid="custom_valid2=$event")
          .row
            .columns.large-12
              .field
                label
                  | {{t('app.ncsa.graduation')}}
                  span.required *
                validation-provider(rules="required" name="graduation_year" v-slot="{ errors }")
                  .select(:class="{error: errors[0]}")

                    span.selected
                      span.value {{data.graduation_year || t('app.general.select_option')}}
                      span.caret
                    select(v-model="data.graduation_year",  )
                      option(v-for="year in years" :value="year") {{year}}
            .columns.large-12
              .field
                label
                  | {{t('app.ncsa.sport')}}
                  span.required *
                validation-provider(rules="required" name="sport_id" v-slot="{ errors }")
                  .select(:class="{error: errors[0]}")
                    span.selected
                      span.value {{sports[data.sport_id] || t('app.general.select_option')}}
                      span.caret
                    select(v-model="data.sport_id",  )
                      option(v-for="sport in sports_arr" :value="sport[0]") {{sport[1]}}
          .row
            .columns.large-24
              .field.checkbox-field2
                label(for="consent")
                  validation-provider(rules="required" name="consent" v-slot="{ errors }")
                    input(type="checkbox" v-model="data.consent" id="consent" class="no-custom" :class="{error: errors[0]}")
                    span.label-text(v-html="t('app.ncsa.consent', {link: `<a href='https://www.imgacademy.com/privacy-policy?website=ncsasports.org' target='_blank'>${t('app.ncsa.privacy_policy')}</a>`})" :class="{error: consent_error }")
                    span.disclaimer 
                      div.legal_statement(v-html="t('app.ncsa.disclaimer')") 
          .row
            .columns.large-24
              .buttons.reverse-button-order
                .left
                  a(@click="$emit('close')" class="button secondary") {{t('app.buttons.cancel')}}
                .right
                  a(class="button" @click="save") {{t('app.buttons.submit')}}

</template>
<script>
import Modal   from './_modal'
import ncsalogo from 'images/NCSA_logo.png'
import green_check from 'images/green_check.png'
import flatPickr from 'vue-flatpickr-component';
import phone from "components/phone"

const sports = {17706:"Baseball", 17737:"Cheerleading", 17732:"eSports", 17711:"Field Hockey", 17633:"Football", 17638:"Men's Basketball", 17652:"Men's Diving", 17659:"Men's Golf", 17665:"Men's Ice Hockey", 17707:"Men's Lacrosse", 17644:"Men's Rowing", 17683:"Men's Soccer", 17687:"Men's Swimming", 17689:"Men's Tennis", 17691:"Men's Track", 17695:"Men's Volleyball", 17701:"Men's Water Polo", 17634:"Softball", 17639:"Women's Basketball", 17730:"Women's Beach Volleyball", 17653:"Women's Diving", 17736:"Women's Flag Football", 17660:"Women's Golf", 17735:"Women's Gymnastics", 17666:"Women's Ice Hockey", 17708:"Women's Lacrosse", 17645:"Women's Rowing", 17684:"Women's Soccer", 17688:"Women's Swimming", 17690:"Women's Tennis", 17692:"Women's Track", 17696:"Women's Volleyball", 17702:"Women's Water Polo", 17731:"Women's Wrestling", 17635:"Wrestling"}

export default {
  components: {Modal, flatPickr, phone},
  props: ['show', 'event_id', 'program_id', 'organization_id', 'registration_id', 'program_name', 'org_name', 'ncsa_modal_data', 'interest_level'],
  data() {
    return {
      data: {athlete_or_parent: 'parent'},
      conf: {enableTime: false, dateFormat: 'Y-m-d',altFormat: 'm-d-Y',altInput:true, wrap: true, altInputClass:"flatpckr"},
      ncsalogo,
      green_check,
      sports: sports,
      custom_valid1: false,
      custom_valid2: false,
      birth_date_error: false,
      done: false,
      saving: false,
      consent_error: false
    }
  },
  watch: {
    show(){
      if(this.show){this.done = false; this.data = {athlete_or_parent: 'parent'}}
    }
  },
  updated() {
    this.processData(this.ncsa_modal_data);
  },
  methods: {
    processData(data) {
      let partParentContactCount = 0;
      let parentInfoSet = false;
      const handlers = {
        'Product::FormBlock::PartParent': (item) => {
          if ((!parentInfoSet) && ((item.handle === "parentguardian" || (item.handle !== "parentguardian" && item.handle === "second-parentguardian")) || (
            (item.form_block.form_part._main_form_block.connection_type.name === "First Parent or Guardian" || (
            item.form_block.form_part._main_form_block.connection_type.name !== "First Parent or Guardian" && 
            item.form_block.form_part._main_form_block.connection_type.name === "Second Parent or Guardian" 
            ))))
          ) {
            this.data.parent_first_name = item.entity_attrs ? item.entity_attrs.first_name : item.entity.first_name;
            this.data.parent_last_name = item.entity_attrs ? item.entity_attrs.last_name : item.entity.last_name;
            parentInfoSet = true; 
          }
        },
        'Product::FormBlock::PartPerson': (item) => {
          this.data.athlete_first_name = item.entity_attrs ? item.entity_attrs.first_name : item.entity.first_name;
          this.data.athlete_last_name = item.entity_attrs ? item.entity_attrs.last_name : item.entity.last_name;
          this.data.birth_date = item.entity_attrs ? item.entity_attrs.birth_date : item.entity.birth_date;
        },
        'Product::FormBlock::PartPersonSchool': (item) => {
          this.data.graduation_year = item.entity_attrs ? item.entity_attrs.year : item.entity.year;
        },
        'Product::FormBlock::PartPersonContact': (item) => {
          const getPhone = (cellPhone) => {
            if (typeof cellPhone === 'string') return cellPhone;
            if (typeof cellPhone === 'object' && cellPhone?.phone) return cellPhone.phone;
            return '';
          };
          this.data.athlete_phone = getPhone(item.entity_attrs?.cell_phone) || getPhone(item.entity?.cell_phone);
          this.data.athlete_email = item.entity_attrs ? item.entity_attrs.email : item.entity.email;
        },
        'Product::FormBlock::PartParentContact': (item) => {
          partParentContactCount++;
          if (partParentContactCount === 1 || item.form_block.form_part._main_form_block.connection_type.name === "First Parent or Guardian") {
            this.data.parent_email = item.entity_attrs ? item.entity_attrs.email : item.entity.email;
            const getPhone = (cellPhone) => {
              if (typeof cellPhone === 'string') return cellPhone;
              if (typeof cellPhone === 'object' && cellPhone?.phone) return cellPhone.phone;
              return '';
            };
            this.data.parent_phone = getPhone(item.entity_attrs?.cell_phone) || getPhone(item.entity?.cell_phone);
          }
        },
        'Product::FormBlock::PartAddress': (item) => {
          this.data.zip = item.entity_attrs ? item.entity_attrs.zip_code : item.entity.zip_code;
        }
      };
      data.forEach(item => {
        const handler = handlers[item.style];
        if (handler) {
          handler(item);
        }
      });
    },
    validate_birth(){
      if (!this.data.birth_date) return
      this.birth_date_error = moment().subtract(13, 'years') < moment(this.data.birth_date)
    },
    save(){
      if(this.saving) return false
      this.$refs.observer.validate().then((valid) => {
        this.validate_birth()
        if(this.data.consent){
          this.consent_error = false
        }else{
          this.consent_error = true
          return false
        }
        if (!valid || !this.custom_valid1 || !this.custom_valid2 || this.birth_date_error) return
        this.data.event_id = this.event_id
        if(this.org_name){
          this.data.additional_data = {
             "partner_registration_info": this.org_name + " " + this.program_name + "^" + this.interest_level,
             interest_level: Number(this.interest_level)
          }
        }
        this.data.additional = {}
        this.data.additional.user_id = this.state.current_user.id
        this.data.additional.program_id = this.program_id
        this.data.additional.organization_id = this.organization_id
        this.data.additional.registration_id = this.registration_id
        this.saving = true
        this.axios.post(`/api2/family/registrations/send_data_to_ncsa`, {recruit: this.data}).then((resp)=>{
          console.log('Response from NCSA', resp.data)
          this.done = true
          this.saving = false
        })
      })
    }
  },
  computed:{
    environment(){
      return process.env.NODE_ENV
    },
    years(){
      return [...Array(2099 - 2021 + 1).keys()].map(x => x + 2021);
    },
    sports_arr(){
      return Object.entries(this.sports);
    }
  }

}
</script>
<style scoped lang="scss">
.modal_ncsa_logo{
  width:130px;
}
.green_check{
  width: 15%;
}
header{
  font-size:16px !important;
}
.checkbox-field2{
  .label-text{
    &.error{
      font-size: 14px;
      font-weight: 600;
    }
  }
}

.modal-content{
  .row{
    .columns.large-24{
      &.block-header{
        font-weight: 600;
        padding-top: 40px;
        padding-bottom: 15px;
      }
      ul{
        list-style: disc;
        margin-left: 30px;
        font-size: 14px;
        line-height: 1;
      }
    }
  }
}

.disclaimer{
      color: grey;
      font-size: 0.625rem;
      font-weight: 600;
      .legal_statement{
        margin-left: 2rem;
        margin-right: 1rem;
      }
}
</style>
